import { render, staticRenderFns } from "./coursedescription.vue?vue&type=template&id=5008aefa&scoped=true&"
import script from "./coursedescription.vue?vue&type=script&lang=js&"
export * from "./coursedescription.vue?vue&type=script&lang=js&"
import style0 from "./coursedescription.vue?vue&type=style&index=0&id=5008aefa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008aefa",
  null
  
)

export default component.exports